import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
// import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import FeatureCard from '../../components/FeatureCard/FeatureCard';
const free = require('../../images/100free.png');
const free_red = require('../../images/100free_red.png');
const customrecord = require('../../images/customrecord.png');
const customrecord_red = require('../../images/customrecord_red.png');
const greatquality = require('../../images/greatquality.png');
const greatquality_red = require('../../images/greatquality_red.png');
const premiumfeature = require('../../images/premiumfeature.png');
const premiumfeature_red = require('../../images/Premiumfeature_red.png');
const quickrecord = require('../../images/quickrecord.png');
const quickrecord_red = require('../../images/Quickrecord_red.png');
const videoquality = require('../../images/videoquality.png');
const videoquality_red = require('../../images/videoquality_red.png');
import { colors, fontSizes,fontFamily } from '../../styles/variables';
//const poppins= <link rel="import" href="@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@600&display=swap');"/>

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexGrow: 1,
      paddingLeft:'13em',
      paddingRight:'13em',
      '@media only screen and (max-width: 959px)': {
        paddingLeft:0,
        paddingRight:0,
        // maxWidth: "62%",
      },
    },
    root3: {
      flexGrow: 1,
      margin: 0,
      padding: 0,
      // height: '100vh',
      // transformOrigin:'cillum',
      backgroundColor:'#F7F7F7'
    },
    container:{
      margin:0,
      width:'100%'
    },
    paper: {
      width: 279,
      height: '100%',
      borderRadius:19,
      boxShadow:'none',
      paddingBottom:20,
      // textTransform:'lowercase'
    },
    featureItemImage:{
      width:60,
      justifyContent:'center',
      objectFit:'contain'
    },
    featureItemImage2:{
      width:35,
      justifyContent:'center',
      objectFit:'contain'
    },
    featureItemImageDiv:{
      display:'flex',
      paddingTop:60,
      paddingBottom:30,
      justifyContent:'center',
      alignContent:'center',
    },
    Typography:{
      fontFamily:fontFamily.poppins,
      fontSize:fontSizes.md.large,
      fontWeight:'bold',
      color:'black',
      textAlign:'left',
      paddingLeft:'2%',
      paddingTop:'10%',
      paddingBottom:'2%',
      '@media only screen and (max-width: 959px)': {
        textAlign:'center',
        paddingLeft:0
        // maxWidth: "62%",
      }, 
    },
  }),
);

export default function SpacingGrid() {
  const classes = useStyles();
  return (
  <div className={classes.root3} id="feature">
    <Grid container className={classes.root}>
      <Grid item xs={12}>
      <Typography className={classes.Typography}>Features</Typography>
        <Grid container justify="center" spacing={3} className={classes.container} >
      
             <FeatureCard
               image2={quickrecord}
               image3={quickrecord_red}
               image4={quickrecord}
               heading1="Quick Record"
               description="Click on record, select if you want audio and start capturing your screen."
             />
             <FeatureCard
               image1={customrecord}
               image5={customrecord_red}
               image6={customrecord}
               heading1="Custom Record"
               description="Record as and when you want. Use the online video trimmer to customize your recordings"
             />
             <FeatureCard
               image1={greatquality}
               image5={greatquality_red}
               image6={greatquality}
               heading1="Great Quality"
               description="Record at 1080p or a set a resolution of your choice. Our videos download as .webm the hottest and web optimized video format with a very small file size"
             />
             <FeatureCard
               image1={free}
               image5={free_red}
               image6={free}
               heading1="100% Free"
               description="Free user accounts, video recordings and local savings"
             />
             <FeatureCard
               image1={videoquality}
               image5={videoquality_red}
               image6={videoquality}
               heading1="Video Quality"
               description="Pick your screen recorder video resolution from 1080p, 720p, 360p as you need"
             />
             <FeatureCard
               image1={premiumfeature}
               image5={premiumfeature_red}
               image6={premiumfeature}
               heading1="Premium Features"
               description="Signup for Cloud back up, categorized and sorted videos you can access from any device with our premium plans starting from low as $1.99 a month"
             />
         </Grid>
      </Grid>
    </Grid>
    <div style={{height:100}}></div>
  </div>
  );
}
